import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { Check, X } from "lucide-react";

export const TransactionsSection = ({ transactions, users, fetchData }) => {
  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const handleApprove = async (txnId) => {
    try {
      await axios.put(`${API}/admin/transactions/${txnId}/approve`, {}, { headers: getAuthHeaders(), withCredentials: true });
      toast.success("Transaction approved");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to approve");
    }
  };

  const handleReject = async (txnId) => {
    try {
      await axios.put(`${API}/admin/transactions/${txnId}/reject`, {}, { headers: getAuthHeaders(), withCredentials: true });
      toast.success("Transaction rejected");
      fetchData();
    } catch { toast.error("Failed to reject"); }
  };

  return (
    <Card className="bg-white border-slate-200">
      <CardHeader className="border-b border-slate-100">
        <CardTitle className="text-slate-800 font-heading">Transaction Management</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-left text-slate-500 text-xs uppercase tracking-wider bg-slate-50">
                <th className="px-5 py-3 font-semibold">ID</th>
                <th className="px-5 py-3 font-semibold">User</th>
                <th className="px-5 py-3 font-semibold">Type</th>
                <th className="px-5 py-3 font-semibold">Method</th>
                <th className="px-5 py-3 font-semibold">Amount</th>
                <th className="px-5 py-3 font-semibold">Status</th>
                <th className="px-5 py-3 font-semibold">Date</th>
                <th className="px-5 py-3 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {transactions.map((txn) => {
                const txnUser = users.find((u) => u.user_id === txn.user_id);
                return (
                  <tr key={txn.transaction_id} className="hover:bg-slate-50">
                    <td className="px-5 py-3 text-slate-400 font-mono text-xs">{txn.transaction_id.slice(0, 12)}...</td>
                    <td className="px-5 py-3 text-slate-700 text-sm">{txnUser?.email || "Unknown"}</td>
                    <td className="px-5 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium capitalize ${
                        txn.type === "deposit" ? "bg-emerald-100 text-emerald-700" :
                        txn.type === "withdrawal" ? "bg-rose-100 text-rose-700" :
                        txn.type === "crypto_purchase" ? "bg-blue-100 text-blue-700" :
                        txn.type === "referral_bonus" ? "bg-amber-100 text-amber-700" :
                        "bg-slate-100 text-slate-600"
                      }`}>{txn.type.replace("_", " ")}</span>
                    </td>
                    <td className="px-5 py-3 text-slate-500 text-xs">
                      {txn.withdrawal_method ? txn.withdrawal_method.replace("_", " ").toUpperCase() : txn.crypto_type ? txn.crypto_type.replace("_", " ").toUpperCase() : "-"}
                    </td>
                    <td className="px-5 py-3 text-slate-700 font-mono text-sm">
                      ${txn.amount.toLocaleString()}
                      {txn.type === "withdrawal" && txn.vat_amount != null && (
                        <span className="block text-xs text-rose-500">VAT: -${txn.vat_amount.toLocaleString()} | Net: ${txn.net_amount.toLocaleString()}</span>
                      )}
                    </td>
                    <td className="px-5 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                        txn.status === "completed" ? "bg-emerald-100 text-emerald-700" :
                        txn.status === "pending" ? "bg-amber-100 text-amber-700" :
                        "bg-rose-100 text-rose-700"
                      }`}>{txn.status}</span>
                    </td>
                    <td className="px-5 py-3 text-slate-500 text-sm">{new Date(txn.created_at).toLocaleDateString()}</td>
                    <td className="px-5 py-3">
                      {txn.status === "pending" && (
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-emerald-500 hover:text-emerald-600" onClick={() => handleApprove(txn.transaction_id)} data-testid={`approve-txn-${txn.transaction_id}`}><Check className="w-4 h-4" /></Button>
                          <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-rose-500 hover:text-rose-600" onClick={() => handleReject(txn.transaction_id)}><X className="w-4 h-4" /></Button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
